import apiClient from './apiClient'
import { API_CONFIG } from './config'
import { mockUser, delay } from './mockData'
import axios from 'axios'
import { apiConfig } from '../config/authConfig'

const login = async (userData) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: login')
    // Simulate login validation
    if (userData.username && userData.password) {
      const mockResponse = {
        success: true,
        user: mockUser,
        token: 'mock-jwt-token-' + Date.now(),
      }
      localStorage.setItem('user', JSON.stringify(mockResponse))
      return delay(mockResponse)
    }
    throw new Error('Invalid credentials')
  }
  
  const response = await apiClient.post('/auth/login', userData)
  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data))
  }
  return response.data
}

const loginUser = async (email) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: login user', email)
    const mockResponse = {
      isAuthenticated: true,
      fullName: 'Mock User',
      userEmailID: email,
      userHasAccess: true,
      userAppRoles: 'Admin',
      userCurrentRole: 'Admin',
      userGPN: 'MOCK123',
      tokenID: 'mock-token-' + Date.now(),
      requestIsSuccess: true,
    }
    return delay(mockResponse)
  }
  
  const response = await apiClient.get(`/Login/LoginUser`, {
    params: { email }
  })
  return response.data
}

const loginUserAzure = async (azureToken) => {
  if (API_CONFIG.useMockData) {
    console.log('📦 Using mock data: login user azure')
    const mockResponse = {
      isAuthenticated: true,
      fullName: 'Mock Azure User',
      userEmailID: 'mockuser@ey.com',
      userHasAccess: true,
      userAppRoles: 'Admin',
      userCurrentRole: 'Admin',
      userGPN: 'MOCK123',
      tokenID: 'mock-token-' + Date.now(),
      requestIsSuccess: true,
    }
    return delay(mockResponse)
  }
  
  // Use direct axios call to bypass interceptor and set custom header
  const response = await axios.get(`${apiConfig.uri}/Login/LoginUserAzure`, {
    headers: {
      'AzureAccessToken': azureToken,
      'Content-Type': 'application/json',
      'Accept': '*/*',
    },
    withCredentials: false
  })
  return response.data
}

const logout = () => {
  localStorage.removeItem('user')
}

const authService = {
  login,
  loginUser,
  loginUserAzure,
  logout,
}

export default authService
